type ParameterObject = {
    [key: string]: any; 
 };
 
export const extractValues = (inputObject: ParameterObject) => {
    return Object.keys(inputObject).reduce((valuesArray, key) => {
        valuesArray.push(inputObject[key]);
        return valuesArray;
    }, [] as any);
 }